// This file contains the shared default values for all environments
// The individual values can be specifically overwritten for each environment

export const defaultEnvironment = {
  app_name: 'landlord',
  auth_header_name: 'authorization',
  file_download_auth_name: 'X-Auth-Token',
  ftp_port: '2222',

  freshchat_token: 'eb7c3c1d-844a-4204-9f31-6d02431b9963',
  google_api_key: 'AIzaSyCKak0N8a6sx3K3SS4WoRwZTybT8GYz8qk',
  survicate_workspace_key: '8b14a7f4c0f657d7b9747c9705b00084',
  keycloakConfig: {
    'ssl-required': 'none',
    resource: 'immomio-oidc',
    'public-client': true,
    'verify-token-audience': true,
    'use-resource-role-mappings': true,
    'confidential-port': 0
  }
};

export const residentAppsDefaultCustomerIndents = {
  abg_customer: {
    ident: 'ca0dda11-37bd-4163-bf38-254c67c4da0b',
    permissions: ['test'],
    blocked_permissions: ['blocked']
  },

  naheimst_customer: {
    ident: '05aa9e7d-5200-49aa-9853-fd06e65fd8a7',
    permissions: ['test'],
    blocked_permissions: ['blocked']
  },

  hanova_customer: {
    ident: '71123ecd-fa0f-410b-863a-01d1b189fa7f'
  },

  wobau_customer: {
    ident: '154f7955-e15c-4b34-83d9-f1de5ebf2fc9'
  },

  wankendorfer_customer: {
    ident: '4a288ed1-04ef-4f82-86c5-feb65bc2ea2f'
  }
};

export const residentAppsProductionCustomerIndents = {
  abg_customer: {
    ident: '54d4d117-4fbf-454b-a023-684f403103f2'
  },

  naheimst_customer: {
    ident: '76c142c9-91b6-48c6-afe3-49040a283613',
    permissions: ['test'],
    blocked_permissions: ['blocked']
  },

  hanova_customer: {
    ident: '11e73e30-64c6-2b1f-d1ae-3a8fb320fe15'
  },

  wobau_customer: {
    ident: '2012c752-40e2-450e-a685-4ca0a40c0e95'
  },

  wankendorfer_customer: {
    ident: '9bf3b295-70d7-15f8-3295-49e0911a7b18'
  }
};
